import { useEffect } from 'react';
import useStore from './zustand/useStore';
import SearchBar from './components/SearchBar';
import FilterBarSocialEvent from './components/FilterBarSocialEvent';
import FilterBarDailySchedule from './components/FilterBarDailySchedule';
import FilterChips from './components/FilterChips';
import ListView from './components/ListView';
import CardView from './components/CardView';
import InfoBar from './components/InfoBar';

import './App.css';

const App = () => {
  const { updateSettings, updateData, filters, view, settings } = useStore((state) => ({
    updateSettings: state.updateSettings,
    updateData: state.updateData,
    filters: state.filters,
    view: state.view,
    settings: state.settings,
  }));

  useEffect(() => {
    const getWPSettings = async () => {
      await updateSettings();
    };
    const getData = async () => {
      await updateData();
    };
    getWPSettings();
    getData();
  }, [updateData, updateSettings]);
  return (
    <div className="App">

      {/* display info bar component only for social events */}
      {/*settings.params.datasource === 'social_events' ? <InfoBar/> : null*/}
      
      {/* display Search bar component */}
      <SearchBar />

      {/* display Filters component */}
      {settings.params.datasource === 'social_events' ?<FilterBarSocialEvent /> : <FilterBarDailySchedule />}
      

      {/* display filter chips component only if filters values are not null */}
      {filters.search.length > 0 ||
      filters.DateSession.length > 0 ||
      filters.TimeSession.length > 0  ||
      filters.Venue.length > 0  ||
      filters.MeetingGroup.length > 0  ||
      filters.MeetingType.length > 0  ||
      filters.Message.length > 0  ? (
        <FilterChips />
      ) : null}
   
      {/* display Data grid component */}
      {view === 'card' ? <CardView /> : <ListView />}
    </div>
  );
};

export default App;
